import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isActive = (path) => location.pathname === path;

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const toggleMobileMenu = () => {
        console.log('Menu toggled, current state:', mobileMenuOpen);
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <Link to="/" className="logo" onClick={closeMobileMenu}>
                    <img src="/NIDLOGO.jpeg" alt="Nidharsanam Public Charitable Trust Logo" className="logo-img" />
                    <span>
                        <div className="logo-line-1">NIDHARSANAM</div>
                        <div className="logo-line-2">PUBLIC CHARITABLE TRUST</div>
                    </span>
                </Link>
                
                <ul className={`nav-links ${mobileMenuOpen ? 'mobile-active' : ''}`}>
                    <li><Link to="/" className={isActive('/') ? 'active' : ''} onClick={closeMobileMenu}><i className="fas fa-home"></i> Home</Link></li>
                    <li><Link to="/about" className={isActive('/about') ? 'active' : ''} onClick={closeMobileMenu}><i className="fas fa-info-circle"></i> About</Link></li>
                    <li><Link to="/programs" className={isActive('/programs') ? 'active' : ''} onClick={closeMobileMenu}><i className="fas fa-tasks"></i> Projects</Link></li>
                    <li><Link to="/gallery" className={isActive('/gallery') ? 'active' : ''} onClick={closeMobileMenu}><i className="fas fa-images"></i> Gallery</Link></li>
                    <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={closeMobileMenu}><i className="fas fa-envelope"></i> Contact</Link></li>
                </ul>
                
                <button 
                    className="mobile-menu-toggle" 
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                    type="button"
                >
                    <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                </button>
            </div>
            {mobileMenuOpen && <div className="mobile-backdrop" onClick={closeMobileMenu}></div>}
        </nav>
    );
};

export default Navbar;
